import type { WordCollection } from "../collection.types";

export const ripeningCollection: WordCollection = {
  id: "ripening",
  title: "Ripening & Radiance",
  icon: "wheat",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 6, 1), // July 1st
  endDate: new Date(new Date().getFullYear(), 7, 31), // August 31st
  words: [
    "bronze",
    "copper",
    "corn",
    "delicate",
    "field",
    "garden",
    "gentle",
    "golden",
    "grain",
    "honey",
    "nectar",
    "pastoral",
    "peaceful",
    "pepper",
    "soft",
    "sweet",
    "sweet",
    "tender",
    "tomato",
    "warm",
    "wheat",
  ],
};
